module.exports = __webpack_public_path__ + "img/ep-3.34044e60.jpg";